import axios from "axios";

// Sempre usa /api — nginx faz proxy para o backend (funciona local e OCI VM)
const api = axios.create({ baseURL: "/api", timeout: 10000 });

// Sessão expirada/ausente → volta pro login (o cookie de sessão é HttpOnly, só o backend o lê).
// As chamadas de login/sessão tratam o 401 elas mesmas.
api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401 && !url.startsWith("/auth/") && window.location.pathname !== "/login") {
      window.location.assign("/login");
    }
    return Promise.reject(err);
  }
);

export const login        = (usuario, senha) => api.post("/auth/login", { usuario, senha });
export const logout       = ()               => api.post("/auth/logout");
export const getSession   = ()               => api.get("/auth/me");
export const changePassword = (senha_atual, senha_nova) => api.post("/auth/senha", { senha_atual, senha_nova });

export const health        = () => api.get("/health");

export const runGdpb       = (body) => api.post("/gdpb/run", body);
export const runGvc        = (body) => api.post("/gvc/run",  body);
export const runEpeg       = (body) => api.post("/epeg/run", body);
export const uploadEpeg    = (fd)   => api.post("/epeg/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
export const runGnff       = ()     => api.post("/gnff/run", {});
export const downloadGnff  = (jobId) => api.get(`/gnff/download/${jobId}`, { responseType: "blob" });
export const runBip        = (body) => api.post("/bip/run",  body);

export const runMlPremium   = (body) => api.post("/shared/ml-premium/run",   body);
export const runMlMinPrice  = (body) => api.post("/shared/ml-min-price/run", body);
export const runMlPrice     = (body) => api.post("/shared/ml-price/run",     body);
export const runAmzPrice    = (body) => api.post("/shared/amz-price/run",    body);
export const runAmzStock    = (body) => api.post("/shared/amz-stock/run",    body);
export const runAmzFiscal   = (body) => api.post("/shared/amz-fiscal/run",   body);
export const runShopeeAttrs = (body) => api.post("/shared/shopee-attrs/run", body);
export const runShopeePrice = (body) => api.post("/shared/shopee-price/run", body);
export const runSyncImages  = (body) => api.post("/shared/sync-images/run",  body);
export const runMlClose     = (body) => api.post("/shared/ml-close/run",     body);
export const runMlFiscal    = (body) => api.post("/shared/ml-fiscal/run",    body);
export const runNvsPrice    = (body) => api.post("/shared/nvs-price/run",    body);
export const runNvsImages   = (body) => api.post("/shared/nvs-images/run",   body);
export const runNvsAttrs    = (body) => api.post("/shared/nvs-attrs/run",    body);
export const runNvsEan      = (body) => api.post("/shared/nvs-ean/run",      body);
export const runMlAds       = (body) => api.post("/shared/ml-ads/run", body);
export const getMlAdsResultado = ()  => api.get("/shared/ml-ads/resultado");
export const runNvsDescription = (body) => api.post("/shared/nvs-description/run", body);
export const generateNvsDescription = (body) => api.post("/shared/nvs-description/generate", body);
export const runNvsCategory = (body) => api.post("/shared/nvs-category/run", body);
export const runNvsSubcategories = (body) => api.post("/shared/nvs-subcategories/run", body);
export const runBlingDescriptions = (body) => api.post("/shared/bling-descriptions/run", body);
export const runBlingPrice = (body) => api.post("/shared/bling-price/run", body);
export const runProductName = (body) => api.post("/shared/product-name/run", body);

export const getGvcConfig   = ()     => api.get("/config/gvc");
export const saveGvcConfig  = (data) => api.put("/config/gvc",  { data });
export const getGdpbConfig  = ()     => api.get("/config/gdpb");
export const saveGdpbConfig = (data) => api.put("/config/gdpb", { data });
export const getGnffConfig  = ()     => api.get("/config/gnff");
export const saveGnffConfig = (data) => api.put("/config/gnff", { data });
export const getPlanilhaConfig  = ()       => api.get("/config/planilha");
export const savePlanilhaConfig = (fileId) => api.put("/config/planilha", { file_id: fileId });
export const listDicionarios = ()           => api.get("/config/dicionarios");
export const getDicionario   = (nome)       => api.get(`/config/dicionarios/${nome}`);
export const saveDicionario  = (nome, data) => api.put(`/config/dicionarios/${nome}`, { data });

// GAV — Gerenciador de Avaliações (Amazon)
export const getGavPedidos     = (params) => api.get("/gav/pedidos", { params });
export const getGavIndicadores = (params) => api.get("/gav/indicadores", { params });
export const getGavExecucoes   = ()       => api.get("/gav/execucoes");
export const getGavStatus      = ()       => api.get("/gav/status");
export const getGavResumo      = ()       => api.get("/gav/resumo");
export const runGav            = (modo)   => api.post("/gav/run", { modo });
export const solicitarGav      = (id)     => api.post(`/gav/pedidos/${id}/solicitar`);
export const marcarFeedbackVisto = ()     => api.post("/gav/feedback/visto");
export const getGavConfig      = ()       => api.get("/config/gav");
export const saveGavConfig     = (data)   => api.put("/config/gav", { data });

export const getJob        = (id)   => api.get(`/jobs/${id}`);
export const getGvcStatus  = ()      => api.get("/gvc/status");
export const getGvcResults = (n=500) => api.get(`/gvc/results?limit=${n}`);
export const getGvcCsv     = ()      => api.get("/gvc/csv");

export default api;
